import { motion } from "framer-motion";

export const FinalStatement = () => (
  <section
    className="relative h-[100svh] w-full flex flex-col items-center justify-center text-center bg-[#050505] px-6 overflow-hidden"
    data-testid="trust-final"
  >
    <div className="trust-grain absolute inset-0 opacity-[0.05]" />
    <div
      className="pointer-events-none absolute inset-0"
      style={{
        background:
          "radial-gradient(50% 50% at 50% 60%, rgba(74,14,23,0.4) 0%, rgba(5,5,5,0) 70%)",
      }}
    />
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 1.4, ease: [0.16, 1, 0.3, 1] }}
      className="relative z-10 max-w-4xl"
    >
      <h2 className="font-serif text-5xl sm:text-7xl md:text-8xl text-[#F5F5F0] leading-[0.95]">
        Güven Satılmaz.
        <br />
        <span className="italic text-[#C48A5E]">İnşa Edilir.</span>
      </h2>
      <p className="mt-10 font-mono text-[11px] sm:text-xs tracking-[0.22em] text-[#A3A09A] uppercase leading-relaxed max-w-2xl mx-auto">
        Bu içerik sistemi; Ertan Kasap'ın dijital itibarını güçlendirmek, müşteri güvenini
        artırmak, sadakati yükseltmek ve WhatsApp sipariş dönüşümlerini büyütmek için tasarlanmıştır.
      </p>
      <div className="mt-12 mx-auto w-px h-12 bg-gradient-to-b from-[#C48A5E] to-transparent" />
      <span className="mt-6 inline-block font-mono text-[10px] tracking-[0.4em] text-[#C48A5E] uppercase">
        Ertan Kasap · 1985
      </span>
    </motion.div>
  </section>
);

export default FinalStatement;
